import React from 'react'
import { CopyStyle, SubheadSMStyle } from './UI'
import { StyledSlider } from '../templates/jobs'
import { Listbox } from '@headlessui/react'
import tw from 'twin.macro'

const JobFilters = ({ orderLabel, setOrder, setRateSliderValue, rateSliderValue }) => {
  const orders = [
    {
      value: 'newest',
      label: 'Newest'
    },
    {
      value: 'rateHighToLow',
      label: 'Pay Rate highest to lowest'
    },
    // {
    //   value: 'rateLowToHigh',
    //   label: 'Rate Low To High'
    // },
  ]

  return (
    <>
      {/* Search bars */}

      {/* Filters */}
      <div tw='col-span-7 lg:(col-span-6)'>

        <div>
          <div tw='grid grid-cols-12'>
            <div css={[SubheadSMStyle]} tw='col-span-2 text-right relative top-[4px] text-[10px] lg:(col-span-1 text-[18px] text-left)'>Rate</div>
            <div tw='col-span-7 ml-3 lg:(ml-5 col-span-8)'> <StyledSlider
              onChangeCommitted={(e, v) => {
                setRateSliderValue(v)
              }}
              aria-label="Rate"
              defaultValue={30}
              step={10}
              marks
              min={0}
              max={120}
            />
            </div>
            <div css={[CopyStyle]} tw='ml-1 col-span-3 relative top-[4px] text-[10px] lg:(text-[18px] ml-5)'>{`Min $${rateSliderValue}`}</div>
          </div>

        </div>
      </div>

      <div tw='col-span-5 lg:(col-span-6)' >
        <div tw='grid grid-cols-12'>
          <div tw='col-start-2 col-span-4 relative top-[8px] font-bold text-[10px] md:(col-start-4 col-span-2) lg:(col-start-7 col-span-2 text-[18px])'>Order By</div>
          <div tw='col-span-6 lg:(col-span-4)'>
            <Listbox
              // value={order}
              onChange={setOrder}
              as="div"
              tw="relative w-full top-[3px] text-[10px] lg:(text-[18px] top-[1px])"
              className={'order-select-box'}
            >
              {({ open }) => (
                <>
                  <Listbox.Button tw="border border-black bg-white w-full p-7 text-left flex justify-between items-center">
                    <span tw='text-[10px] lg:(text-[14px])'>{orderLabel}</span>
                    <svg
                      width="12"
                      height="7"
                      viewBox="0 0 12 7"
                      fill="none"
                      css={[
                        tw`text-[#FF4D00] stroke-current w-3`,
                        open && tw`rotate-180`,
                      ]}
                    >
                      <path
                        d="M1 1L6 6L11 1"
                        stroke=""
                        strokeWidth="1.04499"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Listbox.Button>
                  <Listbox.Options tw="border border-black bg-white w-full absolute top-full border-t-0 h-[130px] overflow-y-scroll">
                    {orders.map((ord) => {
                      return (
                        <Listbox.Option
                          key={`order-${ord.value}`}
                          value={ord.value}
                        >
                          {({ active, selected }) => (
                            <div
                              css={[
                                tw`px-3 py-2 cursor-pointer text-[10px] lg:(px-7 py-3 text-[14px])`,
                                active && tw`bg-[#E5EEFF]`,
                              ]}
                            >
                              {ord.label}
                            </div>
                          )}
                        </Listbox.Option>
                      )
                    })}
                  </Listbox.Options>
                </>
              )}
            </Listbox>
          </div>

        </div>
      </div>
    </>
  )
}

export default JobFilters
